// pages/NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="wrapper not-found">
            <img src="https://http.cat/404" alt="cat hidden under the papers, error 404 meme"></img>
            <h1>WOMP WOMP 404!</h1>
            <Link to="/" className="not-found__link">Home</Link>
        </div>
    );
}